<template>
  <el-date-picker
        :modelValue="modelValue"
        @update:modelValue="onDateChange"
        type="daterange"
        placeholder="Pick a day"
        :disabled="disabledDate"
        :shortcuts="shortcuts"
        format="DD/MM/YYYY"
      >
      </el-date-picker>
</template>

<script>
import DateTime from "luxon"

export default {
  props: {
    modelValue: Array
  },
  data() {
    return {
      disabledDate: false,
      shortcuts: [
        {
          text: 'วันนี้',
          value: new Date(),
        },
        {
          text: 'เมื่อวาน',
          value: () => {
            const date = new Date()
            date.setDate(date.getDate() - 1)
            return [date, date]
          },
        },
        {
          text: '3 วันที่แล้ว',
          value: () => {
            const curr = new Date; // get current date
            let first = curr.getDate() - 3
            

            let firstday = new Date(curr.setDate(first));
            let lastday = new Date()
            return [
              firstday, 
              lastday
            ]
          },
        },        
        {
          text: 'สัปดาห์นี้',
          value: () => {
            // const date = new Date()
            // const firstDate = date.getDate() - date.getDay()
            const curr = new Date; // get current date
            let first = curr.getDate() + 1 - curr.getDay(); // First day is the day of the month - the day of the week

            let firstday = new Date(curr.setDate(first));
            let lastday = new Date(curr.setDate(curr.getDate() + 6))
            return [
              firstday, 
              lastday
            ]
          },
        },
        {
          text: 'สัปดาห์ที่แล้ว',
          value: () => {
            const curr = new Date; // get current date
            let first = curr.getDate() + 1 - curr.getDay() - 7; // First day is the day of the month - the day of the week

            let firstday = new Date(curr.setDate(first));
            let lastday = new Date(curr.setDate(curr.getDate() + 6))
            return [
              firstday, 
              lastday
            ]
          },
        },
        {
          text: 'เดือนนี้',
          value: () => {
            const date = new Date()
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0); 
            return [firstDay, lastDay]
          },
        },
        {
          text: 'เดือนที่แล้ว',
          value: () => {
            const date = new Date()
            var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            
            var lastDay = new Date(date.getFullYear(), date.getMonth() , 0); 
            return [firstDay, lastDay]
          },
        },
        {
          text: '3 เดือนที่แล้ว',
          value: () => {
            const date = new Date()
            var firstDay = new Date(date.getFullYear(), date.getMonth() - 3, 1);
            
            var lastDay = new Date(date.getFullYear(), date.getMonth() , 0); 
            return [firstDay, lastDay]
          },
        },        
      ],
      value1: '',
      value2: '',
    };
  },
  methods: {
    onDateChange(val) {
      this.$emit("update:modelValue", val)
    }
  }
}
</script>